import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext.jsx';
import FoxMark from '../components/shared/FoxMark.jsx';
import NavMenu from '../components/shared/NavMenu.jsx';

const PAPER = '#F2EBDC';
const INK = '#1B1814';
const GOLD = '#A67C3A';

export default function WeeklyJourney() {
  const navigate = useNavigate();
  const { weeks, completedDays, guide, userProfile } = useApp();

  function getWeekCompletedCount(weekNumber) {
    return (completedDays || []).filter(
      (d) => (d.weekNumber || 1) === weekNumber
    ).length;
  }

  const currentWeek =
    weeks && weeks.length > 0
      ? Math.max(...weeks.map((w) => w.weekNumber))
      : 1;

  return (
    <div style={{ minHeight: '100vh', background: PAPER }}>
      <div
        style={{
          padding: '20px',
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
          alignItems: 'center',
          borderBottom: '1px solid rgba(166,124,58,0.15)',
        }}
      >
        <button
          type="button"
          onClick={() => navigate('/study')}
          style={{
            justifySelf: 'start',
            background: 'none',
            border: 'none',
            color: GOLD,
            fontSize: 22,
            cursor: 'pointer',
            padding: 0,
          }}
        >
          ‹
        </button>
        <span
          style={{
            fontSize: 13,
            color: INK,
            fontFamily: 'Georgia, serif',
            fontStyle: 'italic',
          }}
        >
          My Journey
        </span>
        <div
          style={{
            justifySelf: 'end',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <FoxMark variant="gold" size={24} />
          <NavMenu />
        </div>
      </div>

      <div
        style={{ maxWidth: 480, margin: '0 auto', padding: '24px 20px 80px' }}
      >
        <p
          style={{
            fontFamily: 'Georgia, serif',
            fontSize: 15,
            color: INK,
            opacity: 0.5,
            fontStyle: 'italic',
            marginBottom: 24,
            textAlign: 'center',
          }}
        >
          Prepared for {userProfile?.name || 'you'}
          {guide?.name ? ` · by ${guide.name}` : ''}
        </p>

        {(!weeks || weeks.length === 0) ? (
          <p
            style={{
              fontFamily: 'Georgia, serif',
              fontSize: 15,
              color: INK,
              opacity: 0.4,
              fontStyle: 'italic',
              textAlign: 'center',
              marginTop: 48,
            }}
          >
            Your weeks will appear here as you complete them.
          </p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {weeks.map((week) => {
              const completed = getWeekCompletedCount(week.weekNumber);
              const isCurrentWeek = week.weekNumber === currentWeek;
              const isFullyComplete = completed >= 5;

              return (
                <div
                  key={week.weekNumber}
                  role="button"
                  tabIndex={0}
                  onClick={() =>
                    navigate(`/study/week/${week.weekNumber}`)
                  }
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      navigate(`/study/week/${week.weekNumber}`);
                    }
                  }}
                  style={{
                    background: 'white',
                    border: `1px solid ${
                      isCurrentWeek
                        ? 'rgba(166,124,58,0.4)'
                        : 'rgba(166,124,58,0.15)'
                    }`,
                    borderRadius: 12,
                    padding: '16px 20px',
                    cursor: 'pointer',
                    position: 'relative',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      marginBottom: 8,
                    }}
                  >
                    <div>
                      <p
                        style={{
                          fontSize: 11,
                          color: GOLD,
                          fontFamily: 'Arial, sans-serif',
                          letterSpacing: '0.08em',
                          textTransform: 'uppercase',
                          margin: '0 0 4px',
                        }}
                      >
                        Week {week.weekNumber}
                      </p>
                      <p
                        style={{
                          fontFamily: 'Georgia, serif',
                          fontSize: 17,
                          color: INK,
                          margin: 0,
                        }}
                      >
                        {week.week_title ||
                          week.days?.[0]?.title ||
                          `Week ${week.weekNumber}`}
                      </p>
                    </div>
                    {isFullyComplete ? (
                      <span
                        style={{
                          fontSize: 11,
                          color: GOLD,
                          fontFamily: 'Arial, sans-serif',
                          textTransform: 'uppercase',
                          letterSpacing: '0.06em',
                        }}
                      >
                        ✓ Complete
                      </span>
                    ) : isCurrentWeek ? (
                      <span
                        style={{
                          fontSize: 11,
                          color: INK,
                          opacity: 0.4,
                          fontFamily: 'Arial, sans-serif',
                        }}
                      >
                        {completed}/5 days
                      </span>
                    ) : null}
                  </div>

                  <div
                    style={{
                      height: 3,
                      background: 'rgba(166,124,58,0.1)',
                      borderRadius: 2,
                    }}
                  >
                    <div
                      style={{
                        height: '100%',
                        width: `${(completed / 5) * 100}%`,
                        background: GOLD,
                        borderRadius: 2,
                        transition: 'width 0.5s ease',
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
